export enum Urls {
  PRODUCTION = 'https://app.topperpay.com',
  SANDBOX = 'https://app.sandbox.topperpay.com',
  WEBSITE = 'https://www.topperpay.com/'
}
